<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCategory"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="'Información Básica'"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
              @update-compliance="updateCompliancePercentage"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('production.boxes')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              :box_quantity="boxInspectionForm.box_quantity"
              :box_selected="boxInspectionForm.boxSelected"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('production.defects')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              :box_quantity="boxInspectionForm.box_quantity"
              :box_total_clusters="boxInspectionForm.box_total_clusters"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content
            v-if="boxInspectionForm.box_3lb"
            :title="$t('production.cluster')"
            :before-change="() => validateStep('fourthStep')"
          >
            <fourth-step
              ref="fourthStep"
              :box_quantity="boxInspectionForm.box_quantity"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></fourth-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.analytics')"
            :before-change="() => validateStep('fifthStep')"
          >
            <fifth-step
              ref="fifthStep"
              :box_quantity="boxInspectionForm.box_quantity"
              :compliance_percentage="compliancePercentage"
              :box_selected="boxInspectionForm.boxSelected"
              :box_weight="boxInspectionForm.box_weight"
              :box_total_clusters="boxInspectionForm.box_total_clusters"
              :boxes="boxInspectionForm.boxes"
              :sample_quantity="boxInspectionForm.sample_quantity"
              :defect_box="boxInspectionForm.defect_box"
              :defect_id="boxInspectionForm.defect_id"
              :defect_cluster_quantity="
                boxInspectionForm.defect_cluster_quantity
              "
              :defects="boxInspectionForm.defects"
              :date="boxInspectionForm.date"
              :box_total_rejection="boxInspectionForm.box_total_rejection"
              @on-validated="onStepValidated"
              @conflicts-updated="onConflictsUpdated"
              @showHideLoading="showHideLoading"
            ></fifth-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <br />
            <div>
              <div class="row d-flex justify-content-center">
                <div class="col-12">
                  <table class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('common_words.farm') }}:</strong>
                          </h6>
                          {{ boxInspectionForm.farmSelected }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('production.box') }}:</strong>
                          </h6>
                          {{
                            boxInspectionForm.boxSelected
                              ? boxInspectionForm.boxSelected.name
                              : ''
                          }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong
                              >{{ $t('production.boxes_quantity') }}:</strong
                            >
                          </h6>
                          {{ boxInspectionForm.box_quantity }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong># Pallet:</strong>
                          </h6>
                          {{ boxInspectionForm.pallet_quantity }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('common_words.date') }}:</strong>
                          </h6>
                          {{ formatDate() }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('common_words.location') }}:</strong>
                          </h6>
                          {{ boxInspectionForm.locationSelected }}
                        </td>
                      </tr>

                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('production.boxes') }}:</strong>
                          </h6>
                          <div
                            class="mb-2"
                            v-for="(_, index) in boxInspectionForm.box_quantity"
                            :key="index"
                          >
                            <el-tag
                              style="height: auto; color: black; width: 100%"
                              type="info"
                            >
                              <div class="row pt-2">
                                <div class="col-12 col-sm-4 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('production.box') }} #
                                    </strong>
                                  </h6>
                                  <p>
                                    {{ index + 1 }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.packer') }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{ boxInspectionForm.box_packer[index] }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.box_weight')
                                      }}{{
                                        boxInspectionForm.boxSelected &&
                                        boxInspectionForm.boxSelected
                                          .unit_tara_weight
                                          ? ` (${boxInspectionForm.boxSelected.unit_tara_weight})`
                                          : ''
                                      }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{ boxInspectionForm.box_weight[index] }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.total_clusters') }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_total_clusters[
                                        index
                                      ]
                                    }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.min_caliber') }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_min_caliber[index]
                                    }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.max_caliber') }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_max_caliber[index]
                                    }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.min_length')
                                      }}{{
                                        boxInspectionForm.boxSelected &&
                                        boxInspectionForm.boxSelected
                                          .unit_tara_length
                                          ? ` (${boxInspectionForm.boxSelected.unit_tara_length})`
                                          : ''
                                      }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_min_lenght[index]
                                    }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.max_length')
                                      }}{{
                                        boxInspectionForm.boxSelected &&
                                        boxInspectionForm.boxSelected
                                          .unit_tara_length
                                          ? ` (${boxInspectionForm.boxSelected.unit_tara_length})`
                                          : ''
                                      }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_max_lenght[index]
                                    }}
                                  </p>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-2">
                                  <h6 class="mb-2">
                                    <strong
                                      >{{ $t('boxinspection.total_fingers') }}
                                    </strong>
                                  </h6>
                                  <p>
                                    {{
                                      boxInspectionForm.box_total_fingers[index]
                                    }}
                                  </p>
                                </div>
                              </div>
                            </el-tag>
                          </div>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('production.defects') }}:</strong>
                          </h6>
                          <template
                            v-if="
                              boxInspectionForm.defect_id &&
                              isSet(boxInspectionForm.defect_id[0])
                            "
                          >
                            <div
                              class="mb-2"
                              v-for="(
                                _, index
                              ) in boxInspectionForm.defect_quantity"
                              :key="index"
                            >
                              <el-tag
                                style="height: auto; color: black; width: 100%"
                                type="info"
                              >
                                <div class="row pt-2">
                                  <div class="col-12 col-sm-4 col-lg-2">
                                    <h6 class="mb-2">
                                      <strong>{{
                                        $t('production.box')
                                      }}</strong>
                                    </h6>
                                    <p>
                                      {{ boxInspectionForm.defect_box[index] }}
                                    </p>
                                  </div>
                                  <div class="col-12 col-sm-8 col-lg-5">
                                    <h6 class="mb-2">
                                      <strong
                                        >{{ $t('production.defect') }}
                                        {{ index + 1 }}</strong
                                      >
                                    </h6>
                                    <p>
                                      {{
                                        boxInspectionForm.defect_name_selected[
                                          index
                                        ]
                                      }}
                                    </p>
                                  </div>
                                  <div class="col-12 col-sm-8 col-lg-4">
                                    <h6 class="mb-2">
                                      <strong>{{
                                        $t('boxinspection.cluster_quantity')
                                      }}</strong>
                                    </h6>
                                    <p>
                                      {{
                                        boxInspectionForm
                                          .defect_cluster_quantity[index]
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </el-tag>
                            </div>
                          </template>
                          <el-tag type="warning" v-else>{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr v-if="boxInspectionForm.box_3lb" class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('production.cluster') }}:</strong>
                          </h6>
                          <template>
                            <div
                              class="mb-4"
                              v-for="(
                                _, index
                              ) in boxInspectionForm.box_quantity"
                              :key="index"
                            >
                              <div class="">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('production.box') }}
                                    {{ index + 1 }}</strong
                                  >
                                </h6>
                              </div>
                              <div class="px-3">
                                <div
                                  class="cluster-table-container"
                                  :id="`cluster-table-${index}`"
                                >
                                  <div
                                    class="cluster-table-wrapper"
                                    :style="`min-width: ${getTableMinWidth(
                                      index
                                    )}px;`"
                                  >
                                    <master-table
                                      :columns="getClusterTableColumns(index)"
                                      :infoTable="getClusterTableData(index)"
                                      :indexColumn="{ show: false }"
                                      :showColumnStatus="false"
                                      :showColumnImage="false"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('common_words.analytics') }}:</strong>
                          </h6>
                          <div class="analytics-table">
                            <master-table
                              :columns="getAnalyticsTableColumns()"
                              :infoTable="getAnalyticsTableData()"
                              :indexColumn="{ show: false }"
                              :showColumnStatus="false"
                              :showColumnImage="false"
                              :cellStyle="getAnalyticsCellStyle"
                            />
                          </div>
                        </td>
                      </tr>
                      <!-- Sección de conflictos -->
                      <tr v-if="hasConflicts" class="shadow-sm">
                        <td>
                          <div class="alert alert-warning" role="alert">
                            <h6 class="mb-2">
                              <strong>
                                <i class="fa fa-exclamation-triangle"></i>
                                {{ $t('common_words.conflicts') }}:
                              </strong>
                            </h6>
                            <ul class="mb-0">
                              <li v-for="conflict in conflicts" :key="conflict">
                                {{ conflict }}
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong
                              >{{ $t('production.rejected_boxes') }}:</strong
                            >
                          </h6>
                          <p>
                            {{
                              boxInspectionForm.box_total_rejection
                                ? boxInspectionForm.box_total_rejection
                                : 0
                            }}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, resetObjectProperties } from 'src/util/Util.js';
import { showContinue } from 'src/util/Util.js';
import FifthStep from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/steps/FifthStep.vue';
import FirstStep from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/steps/FirstStep.vue';
import FourthStep from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/steps/FourthStep.vue';
import i18n from 'src/i18n';
import MasterTable from 'src/components/Tables/MasterTable.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SecondStep from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/steps/SecondStep.vue';
import ThirdStep from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/steps/ThirdStep.vue';

export default {
  components: {
    FifthStep,
    FirstStep,
    FourthStep,
    MasterTable,
    SecondStep,
    ThirdStep,
  },
  data() {
    return {
      title: '',
      boxInspectionForm: {
        //step1 model
        isEdit: false,
        id: null,
        farm_id: null,
        box_id: null,
        date_save: null,
        box_quantity: null,
        pallet_quantity: null,
        location_id: null,
        date: null,
        user_id: this.$store.state.auth.user.id,
        box_3lb: false,
        //step2 model
        box_packer: [],
        box_weight: [],
        box_total_clusters: [],
        box_min_caliber: [],
        box_max_caliber: [],
        box_min_lenght: [],
        box_max_lenght: [],
        box_total_fingers: [],
        box_total_rejection: 0,
        //step3 model
        defect_box: [],
        defect_id: [],
        defect_name_selected: [],
        defect_cluster_quantity: [],
        defect_quantity: 1,
        //step4 model
        sample_quantity: [],
        boxes: {},
        //defects model
        defects: [],
        farmSelected: null,
        boxSelected: null,
        locationSelected: null,
      },
      payload: {},
      // Propiedades para manejo de conflictos
      conflicts: [],
      hasConflicts: false,
      // Propiedades para colores de analytics
      compliancePercentage: 0,
    };
  },

  computed: {
    types() {
      return [
        { id: 'calidad local', name: i18n.t('boxinspection.local_quality') },
        {
          id: 'calidad exterior',
          name: i18n.t('boxinspection.external_quality'),
        },
      ];
    },
  },

  watch: {
    'boxInspectionForm.boxes': {
      handler() {
        // Forzar actualización del FifthStep cuando cambien los datos de boxes
        this.$nextTick(() => {
          if (this.$refs.fifthStep) {
            this.$refs.fifthStep.$forceUpdate();
          }
        });
      },
      deep: true,
    },
  },

  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],

  methods: {
    isSet(data) {
      return isset(data);
    },

    formatDate() {
      if (this.boxInspectionForm.date) {
        return moment(this.boxInspectionForm.date).format('YYYY-MM-DD');
      } else {
        return '';
      }
    },

    getClusterTableColumns(boxIndex) {
      const sampleQuantity =
        this.boxInspectionForm.sample_quantity &&
        this.boxInspectionForm.sample_quantity[boxIndex]
          ? this.boxInspectionForm.sample_quantity[boxIndex]
          : 13;

      const columns = [
        {
          prop: 'measurement',
          label: this.$t('boxinspection.measurement'),
          width: 80,
          minWidth: 80,
          align: 'center',
          fixed: 'left',
        },
      ];

      // Agregar columnas dinámicas para cada muestra - todas del mismo tamaño
      for (let i = 0; i < sampleQuantity; i++) {
        columns.push({
          prop: `sample_${i}`,
          label: `${i + 1}`,
          width: 60, // Tamaño uniforme para todas las columnas
          minWidth: 60, // Mismo minWidth para consistencia
          align: 'center',
          resizable: false, // No permitir redimensionar para mantener uniformidad
        });
      }

      return columns;
    },

    getClusterTableData(boxIndex) {
      const sampleQuantity =
        this.boxInspectionForm.sample_quantity &&
        this.boxInspectionForm.sample_quantity[boxIndex]
          ? this.boxInspectionForm.sample_quantity[boxIndex]
          : 13;

      const data = [];

      // Fila de clusters
      const clusterRow = {
        measurement: this.$t('production.cluster'),
      };

      for (let i = 0; i < sampleQuantity; i++) {
        const clusterValue =
          this.boxInspectionForm.boxes &&
          this.boxInspectionForm.boxes[boxIndex] &&
          this.boxInspectionForm.boxes[boxIndex][i]
            ? this.boxInspectionForm.boxes[boxIndex][i].cluster || '-'
            : '-';
        clusterRow[`sample_${i}`] = clusterValue;
      }

      data.push(clusterRow);

      // Fila de pesos
      const weightRow = {
        measurement: this.$t('common_words.weight') + ' (lb)',
      };

      for (let i = 0; i < sampleQuantity; i++) {
        const weightValue =
          this.boxInspectionForm.boxes &&
          this.boxInspectionForm.boxes[boxIndex] &&
          this.boxInspectionForm.boxes[boxIndex][i]
            ? this.boxInspectionForm.boxes[boxIndex][i].peso || '-'
            : '-';
        weightRow[`sample_${i}`] = weightValue;
      }

      data.push(weightRow);

      return data;
    },

    getTableMinWidth(boxIndex) {
      const sampleQuantity =
        this.boxInspectionForm.sample_quantity &&
        this.boxInspectionForm.sample_quantity[boxIndex]
          ? this.boxInspectionForm.sample_quantity[boxIndex]
          : 13;

      // Calcular ancho mínimo: columna de medición (80px) + columnas de datos (60px cada una)
      const measurementColumnWidth = 80;
      const dataColumnsWidth = sampleQuantity * 60;
      const totalWidth = measurementColumnWidth + dataColumnsWidth + 50; // +50 para padding y bordes

      // Asegurar un ancho mínimo que active el scroll
      return Math.max(totalWidth, 600);
    },

    getAnalyticsTableColumns() {
      // Obtener la unidad de peso de la caja seleccionada
      const weightUnit =
        this.boxInspectionForm.boxSelected &&
        this.boxInspectionForm.boxSelected.unit_tara_weight
          ? this.boxInspectionForm.boxSelected.unit_tara_weight
          : 'kg';

      return [
        {
          prop: 'number_box',
          label: this.$t('production.box'),
          align: 'center',
        },
        {
          label:
            this.$t('common_words.weight') +
            ' (' +
            weightUnit +
            ')' +
            this.getMinWeightText(),
          prop: 'weight',
          align: 'center',
        },
        {
          label: this.$t('boxinspection.pcms') + ' (%)' + this.getMinPCMSText(),
          prop: 'pcms',
          align: 'center',
        },
        {
          label:
            this.$t('boxinspection.total_underweight_fingers') +
            this.getMinUnderweightText(),
          prop: 'total_underweight_fingers',
          align: 'center',
        },
      ];
    },

    getAnalyticsTableData() {
      const data = [];

      // Obtener la unidad de peso de la caja seleccionada
      const weightUnit =
        this.boxInspectionForm.boxSelected &&
        this.boxInspectionForm.boxSelected.unit_tara_weight
          ? this.boxInspectionForm.boxSelected.unit_tara_weight
          : 'lb';

      let totalPcms = 0;
      let totalUnderweightFingers = 0;

      for (let i = 0; i < this.boxInspectionForm.box_quantity; i++) {
        // Usar el peso real del paso 2 - convertir a número
        const weight = parseFloat(this.boxInspectionForm.box_weight[i]) || 0;

        // Calcular PCMS usando la fórmula correcta
        const pcms = this.calculatePCMS(i);

        // Calcular gajos bajo peso basado en datos del paso 4 (< 2lb)
        const underweightFingers = this.calculateUnderweightFingers(i);

        // Acumular totales (peso será calculado de forma ponderada)
        totalPcms += pcms;
        totalUnderweightFingers += underweightFingers;

        data.push({
          number_box: i + 1,
          weight: Math.round(weight * 100) / 100, // Limitar peso a 2 decimales
          pcms: pcms, // Ya limitado en calculatePCMS
          total_underweight_fingers: underweightFingers,
        });
      }

      // Agregar fila de totales
      const averagePcms =
        this.boxInspectionForm.box_quantity > 0
          ? totalPcms / this.boxInspectionForm.box_quantity
          : 0;

      // Calcular peso total ponderado
      const weightedAverage = this.calculateWeightedTotalWeight();

      data.push({
        number_box: '',
        weight: Math.round(weightedAverage * 100) / 100, // Peso promedio ponderado
        pcms: Math.round(averagePcms * 100) / 100, // Limitar promedio PCMS a 2 decimales
        total_underweight_fingers: totalUnderweightFingers,
        isTotal: true, // Flag para identificar la fila de totales
      });

      return data;
    },

    calculatePCMS(boxIndex) {
      // Obtener total de clusters del paso 2
      const totalClusters =
        this.boxInspectionForm.box_total_clusters[boxIndex] || 0;

      if (totalClusters === 0) {
        return 100; // Si no hay clusters, PCMS es 100%
      }

      // Calcular clusters descontables (defectos con descuento)
      const discountableClusters = this.calculateDiscountableClusters(boxIndex);

      // Aplicar fórmula PCMS: ((Total Clusters - Cant. Cluster descontables) / Total Clusters) * 100
      const pcms =
        ((totalClusters - discountableClusters) / totalClusters) * 100;

      // Limitar a 2 decimales y asegurar que no sea negativo
      return Math.max(0, Math.round(pcms * 100) / 100);
    },

    calculateDiscountableClusters(boxIndex) {
      let discountableClusters = 0;
      const boxNumber = boxIndex + 1; // Número de caja (1-indexed)

      // Recorrer todos los defectos registrados
      for (let i = 0; i < this.boxInspectionForm.defect_box.length; i++) {
        if (this.boxInspectionForm.defect_box[i] === boxNumber) {
          const defectId = this.boxInspectionForm.defect_id[i];
          const clusterQuantity =
            parseInt(this.boxInspectionForm.defect_cluster_quantity[i]) || 0;

          // Verificar si el defecto es descontable
          if (this.isDefectDiscountable(defectId)) {
            discountableClusters += clusterQuantity;
          }
        }
      }

      return discountableClusters;
    },

    isDefectDiscountable(defectId) {
      // Buscar el defecto en la lista de defectos
      const defect = this.boxInspectionForm.defects.find(
        (d) => d.id === defectId
      );

      // Verificar si el defecto existe y es descontable
      return defect && defect.discountable === true;
    },

    calculateUnderweightFingers(boxIndex) {
      // Obtener los datos de la caja del paso 4
      const boxData = this.boxInspectionForm.boxes[boxIndex] || {};
      const sampleCount = this.boxInspectionForm.sample_quantity[boxIndex] || 0;

      let underweightCount = 0;

      // Si no hay datos del FourthStep (box_3lb es false), retornar 0
      if (
        !this.boxInspectionForm.boxSelected ||
        !this.boxInspectionForm.boxSelected.box_3lb
      ) {
        return 0;
      }

      // Recorrer todas las muestras de la caja
      for (let i = 0; i < sampleCount; i++) {
        const sample = boxData[i];
        if (sample && sample.peso) {
          // Verificar si el peso es menor a 2 lb
          if (parseFloat(sample.peso) < 2.0) {
            underweightCount++;
          }
        }
      }

      return underweightCount;
    },

    calculateWeightedTotalWeight() {
      // Calcular peso total ponderado: suma de pesos / cantidad de cajas
      let totalWeight = 0;

      for (let i = 0; i < this.boxInspectionForm.box_quantity; i++) {
        const weight = parseFloat(this.boxInspectionForm.box_weight[i]) || 0;
        totalWeight += weight;
      }

      // Retornar el promedio ponderado
      return this.boxInspectionForm.box_quantity > 0
        ? totalWeight / this.boxInspectionForm.box_quantity
        : 0;
    },

    transformClustersData() {
      const clustersArray = [];

      // Recorrer cada caja (box) en this.boxInspectionForm.boxes
      Object.keys(this.boxInspectionForm.boxes).forEach((boxIndex) => {
        const boxData = this.boxInspectionForm.boxes[boxIndex];

        // Recorrer cada medición dentro de la caja
        Object.keys(boxData).forEach((measurementIndex) => {
          const measurement = boxData[measurementIndex];

          // Crear el objeto cluster similar al patrón de boxes
          clustersArray.push({
            box_number: parseInt(boxIndex) + 1, // Número de caja
            cluster_number: measurement.cluster,
            weight: parseFloat(measurement.peso) || 0,
          });
        });
      });

      return clustersArray;
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...resetObjectProperties({ ...this.$refs.firstStep.model }),
        user_id: this.$store.state.auth.user.id,
      };
      this.$refs.secondStep.model = {
        ...resetObjectProperties({ ...this.$refs.secondStep.model }),
        box_quantity: 1,
      };
      this.$refs.thirdStep.model = {
        ...resetObjectProperties({ ...this.$refs.thirdStep.model }),
        defect_quantity: 0,
      };
      this.$refs.fourthStep.model = {
        ...resetObjectProperties({ ...this.$refs.fourthStep.model }),
      };
      this.$refs.fifthStep.model = {
        ...resetObjectProperties({ ...this.$refs.fifthStep.model }),
        box_total_rejection: 0,
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      // Convertir la fecha a objeto Date si viene como string
      if (model.date && typeof model.date === 'string') {
        model.date = new Date(model.date);
      }

      this.boxInspectionForm = { ...this.boxInspectionForm, ...model };

      // Forzar actualización del FifthStep cuando cambien los datos de boxes
      if (model.boxes) {
        this.$nextTick(() => {
          if (this.$refs.fifthStep) {
            // Pasar los datos actualizados directamente al FifthStep
            this.$refs.fifthStep.boxes = model.boxes;
            this.$refs.fifthStep.sample_quantity =
              model.sample_quantity || this.boxInspectionForm.sample_quantity;
            this.$refs.fifthStep.$forceUpdate();
            // Detectar conflictos después de actualizar los datos
            this.$refs.fifthStep.detectConflicts();
          }
        });
      }
    },

    onConflictsUpdated(conflictData) {
      this.conflicts = conflictData.conflicts;
      this.hasConflicts = conflictData.hasConflicts;
    },

    // Métodos para generar textos de valores mínimos (copiados de FifthStep)
    getMinWeightText() {
      // Obtener el peso mínimo de la caja seleccionada
      const minWeight =
        this.boxInspectionForm.boxSelected &&
        this.boxInspectionForm.boxSelected.min_weight
          ? parseFloat(this.boxInspectionForm.boxSelected.min_weight)
          : null;

      if (minWeight) {
        const weightUnit =
          this.boxInspectionForm.boxSelected &&
          this.boxInspectionForm.boxSelected.unit_tara_weight
            ? this.boxInspectionForm.boxSelected.unit_tara_weight
            : 'kg';
        return ` (Min: ${minWeight.toFixed(2)} ${weightUnit})`;
      }

      return '';
    },

    getMinPCMSText() {
      // Mostrar el porcentaje mínimo de cumplimiento requerido
      if (
        this.$refs.fifthStep &&
        this.$refs.fifthStep.compliancePercentage > 0
      ) {
        return ` (Min: ${this.$refs.fifthStep.compliancePercentage}%)`;
      }

      return '';
    },

    getMinUnderweightText() {
      // Mostrar el límite mínimo de gajos bajo peso (actualmente fijo en 2 lb)
      return ' (Min: 2 lb)';
    },

    storeUpdateCategory() {
      this.showHideLoading(true);
      this.payload = {
        id: this.boxInspectionForm.id,
        route: 'quality/boxinspections',
        expected_boxes_count: this.boxInspectionForm.box_quantity,
        farm_id: this.boxInspectionForm.farm_id,
        box_id: this.boxInspectionForm.box_id,
        date_save: this.boxInspectionForm.date,
        boxes_quantity: this.boxInspectionForm.box_quantity,
        number_pallet: this.boxInspectionForm.pallet_quantity,
        location_id: this.boxInspectionForm.location_id,
        user_id: this.boxInspectionForm.user_id,
        box_3lb: this.boxInspectionForm.box_3lb,
        rejected_boxes: this.boxInspectionForm.box_total_rejection,
        latitude: this.boxInspectionForm.latitude,
        longitude: this.boxInspectionForm.longitude,
        altitude: this.boxInspectionForm.altitude,

        boxes: this.boxInspectionForm.box_packer.map((boxPacker, index) => ({
          box_number: index + 1,
          packer: boxPacker,
          weight: this.boxInspectionForm.box_weight[index],
          total_clusters: this.boxInspectionForm.box_total_clusters[index],
          min_caliber: this.boxInspectionForm.box_min_caliber[index],
          max_caliber: this.boxInspectionForm.box_max_caliber[index],
          min_length: this.boxInspectionForm.box_min_lenght[index],
          max_length: this.boxInspectionForm.box_max_lenght[index],
          total_fingers: this.boxInspectionForm.box_total_fingers[index],
        })),
      };

      if (isset(this.boxInspectionForm.defect_id[0])) {
        this.payload = {
          ...this.payload,
          defects: this.boxInspectionForm.defect_id.map((defectId, index) => ({
            box_id: this.boxInspectionForm.defect_box[index],
            quality_defect_id: defectId,
            number_clusters:
              this.boxInspectionForm.defect_cluster_quantity[index],
          })),
        };
      }

      if (this.boxInspectionForm.box_3lb && this.boxInspectionForm.boxes) {
        this.payload = {
          ...this.payload,
          clusters: this.transformClustersData(),
        };
      }

      if (this.boxInspectionForm.isEdit) {
        if (this.isUpdate()) {
          Axios.updateMaster(this.payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/boxinspections',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/boxinspections',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    getAnalyticsCellStyle({ row, column, rowIndex, columnIndex }) {
      // Si es la fila de totales, no aplicar color
      const columnProp = column.property;
      if (row.isTotal && columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (row.isTotal) {
        return {};
      }

      // Aplicar colores según la columna
      if (columnProp === 'weight') {
        return this.getWeightCellStyle(row);
      } else if (columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (columnProp === 'total_underweight_fingers') {
        return this.getUnderweightFingersCellStyle(row);
      }

      return {};
    },

    getWeightCellStyle(row) {
      // Obtener el peso mínimo de la caja seleccionada
      const minWeight =
        this.boxInspectionForm.boxSelected &&
        this.boxInspectionForm.boxSelected.min_weight
          ? parseFloat(this.boxInspectionForm.boxSelected.min_weight)
          : 0;

      const currentWeight = parseFloat(row.weight) || 0;

      // Si el peso actual es mayor o igual al mínimo, verde claro, sino rojo claro
      if (currentWeight >= minWeight) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getPCMSCellStyle(row) {
      const currentPcms = parseFloat(row.pcms) || 0;

      // Si el PCMS es mayor o igual al porcentaje mínimo, verde claro, sino rojo claro
      if (currentPcms >= this.compliancePercentage) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getUnderweightFingersCellStyle(row) {
      const currentUnderweightFingers =
        parseInt(row.total_underweight_fingers) || 0;

      // Si hay 0 gajos bajo peso, verde claro, sino rojo claro
      if (currentUnderweightFingers === 0) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    // Método que puede ser llamado desde el FifthStep cuando esté listo
    updateCompliancePercentage(percentage) {
      this.compliancePercentage = parseFloat(percentage) || 0;
    },
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('quality');
  },
};
</script>

<style scoped>
/* Contenedor individual para cada tabla - con scroll interno */
.cluster-table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: white;
  position: relative;
}

/* Wrapper para cada tabla con ancho mínimo calculado */
.cluster-table-wrapper {
  display: block; /* El ancho se establece dinámicamente con min-width */
}

/* Configuración para el master-table */
.cluster-table-wrapper >>> .el-table {
  width: 100%;
  table-layout: fixed;
  border: none;
}

.cluster-table-wrapper >>> .el-table__header-wrapper {
  overflow-x: hidden;
}

.cluster-table-wrapper >>> .el-table__body-wrapper {
  overflow-x: hidden;
}

/* Columnas con tamaño uniforme */
.cluster-table-wrapper >>> .el-table .el-table__cell {
  padding: 8px 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
}

/* Configuración específica para columnas de datos (todas iguales) */
.cluster-table-wrapper
  >>> .el-table__header
  .el-table__cell:not(.el-table__cell--left-fixed) {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}

.cluster-table-wrapper
  >>> .el-table__body
  .el-table__cell:not(.el-table__cell--left-fixed) {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}

/* Columna de medición (fija y más ancha) */
.cluster-table-wrapper
  >>> .el-table
  .el-table__fixed-column--left
  .el-table__cell {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
  background-color: #fff;
  z-index: 10;
  border-right: 2px solid #dcdfe6;
}

/* Header styling similar a FourthStep */
.cluster-table-wrapper >>> .el-table__header .el-table__cell {
  background-color: #f8f9fa;
  font-weight: bold;
  color: #333;
}

/* Asegurar que el contenedor no tenga padding extra */
.cluster-table-wrapper >>> .col-sm-12 {
  padding: 0;
  max-width: 100%;
}

/* Evitar que las filas se desborden */
.cluster-table-wrapper >>> .el-table__row {
  white-space: nowrap;
}

/* Scroll bar styling para cada contenedor individual */
.cluster-table-container::-webkit-scrollbar {
  height: 8px;
}

.cluster-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.cluster-table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.cluster-table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Remover bordes duplicados de Element UI */
.cluster-table-wrapper >>> .el-table--border {
  border: none;
}

.cluster-table-wrapper >>> .el-table--border::after {
  display: none;
}

/* Asegurar que la tabla ocupe todo el ancho del wrapper */
.cluster-table-wrapper >>> .el-table__header,
.cluster-table-wrapper >>> .el-table__body {
  width: 100%;
}

/* Asegurar que cada tabla sea independiente */
.cluster-table-container[id*='cluster-table-'] {
  contain: layout style;
  isolation: isolate;
}

/* Estilos para la tabla de analytics */
.analytics-table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  border: 1px solid white;
  border-radius: 4px;
  background: white;
  position: relative;
}

.analytics-table-container >>> .el-table {
  width: 100%;
  table-layout: fixed;
  border: none;
}

.analytics-table-container >>> .el-table__header .el-table__cell {
  background-color: #f8f9fa;
  font-weight: bold;
}

.analytics-table >>> .el-table__body tr:last-child {
  font-weight: bold;
}

.analytics-table >>> .el-table__body tr:last-child td {
  font-weight: bold;
  border-top: 2px solid #6ba652;
}

.analytics-table >>> .el-table__body tr:last-child td strong {
  color: #6ba652;
}

.analytics-table-container >>> .el-table .el-table__cell {
  padding: 8px 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
}
</style>
